<template lang="pug">


  .goo-pagination
    svg(viewBox="0 0 115 18" xmlns="http://www.w3.org/2000/svg")
      g(filter="url(#goo)")
        //use.moving-dot(xlink:href="#dot-small-1" :transform="`translate(0 ${36*(currSceneIdx)}) scale(1)`")
        use.moving-dot(ref="movingDot" xlink:href="#dot-small-1")
        template(v-for="i in length")
          //use.outer(:ref="'outer'+(i-1)" xlink:href="#dot-large" :transform="`${currSceneIdx === i-1? `translate(0 ${36*(i-1)}) scale(1)`: `translate(4.5 ${36*(i-1)+4.5}) scale(0.5)`}`")
          //use.inner(:ref="'inner'+(i-1)" :xlink:href="`#dot-small-${i%4+1}`" :transform="`${currSceneIdx === i-1? `translate(0 ${36*(i-1)}) scale(1)`: `translate(9 ${36*(i-1)+9}) scale(0)`}`")
          use.outer(:ref="'outer'+(i-1)" xlink:href="#dot-large" :transform="`translate(${30*(i-1)+4.5*t[`t${i}1`]} ${4.5*t[`t${i}1`]}) scale(${1-0.5*t[`t${i}1`]})`")
          use.inner(:ref="'inner'+(i-1)" :xlink:href="`#dot-small-${i%4+1}`" :transform="`translate(${30*(i-1)+9*t[`t${i}2`]} ${9*t[`t${i}2`]}) scale(${1-t[`t${i}2`]})`")

</template>

<script>
  import { mapState, mapMutations } from 'vuex'
export default {
  name: 'goo-pagination',
  components: {},
  data() {
    return {
      t:{
        t11: 1,
        t12: 1,
        t21: 1,
        t22: 1,
        t31: 1,
        t32: 1,
        t41: 1,
        t42: 1,
        t51: 1,
        t52: 1,
      },
      lastIdx: 0

    }
  },
  props: {
    length: {

      default: 4
    },
    currSceneIdx: {
      required: true
    }
  },
  computed: {
    //...mapState('app', ['currSceneIdx', 'mode']),

  },
  mounted() {
    this.animeIn(this.currSceneIdx, 1)

    this.lastIdx = this.currSceneIdx
  },
  beforeDestroy() {},
  methods: {
    animeIn(id, delay){
      let tl = new TimelineMax({
        delay: delay,
        onComplete: () => {
        }
      })
      this.tl = tl
      tl.add('start')
        .set(
          this.$refs.movingDot,
          {
            x: 30*id,
          },
          `start+=0`
        )
        .to(
          this.t,
          0.7,
          {
            [`t${id+1}1`]: 0,
            ease: Power2.easeOut
          },
          `start+=0.3`
        )
        .to(
          this.t,
          0.7,
          {
            [`t${id+1}2`]: 0,
            ease: Power2.easeOut
          },
          `start+=0.4`
        )
    },
    animeOut(id){
      let tl = new TimelineMax({ onComplete: () => {
        }
      })
      this.tl = tl
      tl.add('start')
        .to(
          this.t,
          0.7,
          {
            [`t${id+1}1`]: 1,
            ease: Power2.easeOut
          },
          `start+=0.3`
        )
        .to(
          this.t,
          0.7,
          {
            [`t${id+1}2`]: 1,
            ease: Power2.easeOut
          },
          `start+=0`
        )
        .to(
          this.$el,
          0.7,
          {
            y: 100,
            ease: Power2.easeIn
          },
          `start+=0`
        )
    }
  },
  watch: {
    currSceneIdx(val){
      if (this.tl) {
        this.tl.seek(this.tl.endTime())
        this.tl.kill()
        this.tl = null
      }

        let tl = new TimelineMax({ onComplete: () => {
          }
        })
        this.tl = tl
        tl.add('start')
          .to(
            this.$refs.movingDot,
            0.7,
            {
              x: 30*val,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.t,
            0.7,
            {
              [`t${this.lastIdx+1}1`]: 1,
              ease: Power2.easeOut
            },
            `start+=0.3`
          )
          .to(
            this.t,
            0.7,
            {
              [`t${this.lastIdx+1}2`]: 1,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.t,
            0.7,
            {
              [`t${val+1}1`]: 0,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.t,
            0.7,
            {
              [`t${val+1}2`]: 0,
              ease: Power2.easeOut
            },
            `start+=0.3`
          )


        this.lastIdx = val

      }
      //console.log(currIdx, lastIdx, this.t.t11, this.t.t12)

  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.goo-pagination

  width: 100%
  height: 0.22rem
  position: absolute
  //right: 0.1rem
  left: 0
  bottom: 0.4rem
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column

  //overflow: hidden
  svg
    height: 100%
    //background: #e15125
    margin-left: 0.2rem

  .moving-dot
    fill: $cl-white
    //position: absolute
    //transition: all 0.5s ease-out
    //transform-origin: center
    //top: 0
    //left: 0
    //z-index: 9
    //opacity: 0
    //use
      transform-origin: center
      transform: scale(1.2)

  //.slot
    margin: 0.2rem 0 0.2rem 0
    width: 100%
    z-index: 10
    position: relative
  .outer
    //filter: url('#goo')
    fill: $cl-white
    //transform: scale(0.5)
    //transform-origin: center
    //transition: all 0.5s ease-out 0.3s

    &.active
      //transform: scale(1)
      //transition: all 0.5s ease-out
  .inner

    fill: $cl-lightGold
    //transform: scale(0)
    //transform-origin: center
    //transition: all 0.5s ease-out
    &.active
      //transform: scale(1)
      //transition: all 0.5s ease-out 0.3s









</style>
